import { strokeWidth } from './strokeWidth'

// sx resolves border/borderTop/… string values against theme.borders
// (themeKey 'borders'), so registering the stroke tokens there makes
// e.g. `borderTop: 'stroke.default'` work. Values include `solid`
// because the border shorthand needs a line style; set the colour separately
// via borderColor.
export const borders = {
  stroke: {
    default: `${strokeWidth.default} solid`,
    strong: `${strokeWidth.strong} solid`,
    strongest: `${strokeWidth.strongest} solid`,
  },
} as const
